(function() {
  'use strict';

  /**
   * @ngdoc object
   * @name crewStandByReport.controller:CrewStandByReportCtrl
   *
   * @description
   *
   */
  angular.module('crewStandByReport').controller('CrewStandByReportCtrl',
    CrewStandByReportCtrl);

  function CrewStandByReportCtrl(CommonMasterData, $sce, CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'CrewStandByReportCtrl';
    vm.model = {
      searchPanelToggle : true,
      searchCriteria : {
        fromDate : null,
        toDate : null,
        crewType : null
      },
      masterList : {
        crewTypes : [],
        fromDateFormatInvalid : false,
        toDateFormatInvalid : false,
        fromDateAfterToDate : false,
        isCrewTypeSelected : false
      },
      initialSearchDone : false,
      reportDataURL : null,
      reportServerBaseUrl : null
    };

    // toggle search
    vm.clickOnSearch = function() {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    // submit search
    vm.submitSearch = function(params) {
      searchCrewSignInReport(params);
    };

    // on change search field
    vm.changeSearchField = function(searchParams, flag) {
      setDateValidationFlags();
      if (!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid) {
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        } else {
          vm.model.masterList.fromDateAfterToDate = false;
        }
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }

      if ((flag == 'crewType') && !vm.model.masterList.fromDateFormatInvalid
        && !vm.model.masterList.toDateFormatInvalid && !vm.model.masterList.fromDateAfterToDate){
        if ((!!vm.model.searchCriteria.crewType
            && !!vm.model.searchCriteria.crewType.crewTypeCode)) {
          vm.model.masterList.isCrewTypeSelected = false;
        } else {
          vm.model.masterList.isCrewTypeSelected = true;
        }
      }
    };

    function setDateValidationFlags() {
      // if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }

      // if to date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }

    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    // check from date and to date
    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    }
    ;

    // check to date is a future date
    function istoDateFutureDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isAfter(moment().toDate());
    }
    ;

    // search Crew Water Consumption Report
    function searchCrewSignInReport(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;
        var reportDesign = "crew_standby.rptdesign";
        var url = CommonLogicService.getReportUrl(reportDesign,
          getSearchParamMap(param));
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
      }
    }

    // set search param map
    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["fromDate"] = param.fromDate;
      searchParamMap["toDate"] = param.toDate;
      if (!!param.crewType && !!param.crewType.crewTypeCode) {
        searchParamMap["crewType"] = param.crewType.crewTypeCode;
      }
      return searchParamMap;
    }

    function isValidSearchParams(params) {
      setDateValidationFlags();
      // if date invalid
      if (vm.model.masterList.toDateFormatInvalid
        || vm.model.masterList.fromDateFormatInvalid) {
        return false;
      } else if (istoDateBeforeFromDate()) {
        vm.model.masterList.fromDateAfterToDate = true;
        return false;
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
        if ((!!vm.model.searchCriteria.crewType
            && !!vm.model.searchCriteria.crewType.crewTypeCode)) {
          vm.model.masterList.isCrewTypeSelected = false;
          return true;
        }
        vm.model.masterList.isCrewTypeSelected = true;
        return false;
      }
    }

    ( // load crew Types
      function loadCrewTypes() {
        CommonMasterData.getCrewTypeList(function(crewTypes) {
          vm.model.masterList.crewTypes = crewTypes;
          console.log(crewTypes);
        }, function() {
          console.log('Crew type retrieval error');
        });
      })();

  }
}());
